/* src/app/warehousing/pages/report-slow-moving/report-slow-moving.component.scss */
/*# sourceMappingURL=report-slow-moving.component.css.map */
